const MENU = [
  {
    name: 'Load balancer',
    link: '#balancer',
    className: 'gtm-load-balancer-button',
  },
  {
    name: 'RPC map',
    link: '#map',
  },
  {
    name: 'RPC Explorer',
    link: 'endpoints',
  },
  {
    name: 'Roadmap',
    link: '#roadmap',
  },
  {
    name: 'Partners',
    link: '#partners',
  },
  {
    name: 'Contact us',
    link: '#contact',
  },
  {
    name: 'FAQ',
    link: '#faq',
  },
]

export default MENU
